import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  JobOptionsButtonWrapper,
  DropdownWrapper,
  DropdownList,
  DropdownListItem,
} from "./styles/edit-button-styles";

class JobOptionsButton extends Component {
  constructor(props) {
    super(props);
    this.jobOptionsDropdown = React.createRef();

    this.state = {
      editButtonDropdownActive: false,
    };
  }

  componentDidMount() {
    this.handleDropdownOutsideClick();
  }

  componentWillUnmount() {
    this.handleDropdownOutsideClick();
  }

  handleJobOptionsButton = () => {
    this.setState(({ editButtonDropdownActive }) => ({
      editButtonDropdownActive: !editButtonDropdownActive,
    }));
  };

  handleCopyJobLink = () => {
    const { copyJobUrl } = this.props;
    window.location.href = copyJobUrl;
  };

  handleCloseJobLink = () => {
    const { closeJobUrl } = this.props;
    window.location.href = closeJobUrl;
  };

  handleDropdownOutsideClick = () => {
    document.addEventListener("click", (e) => {
      const { editButtonDropdownActive } = this.state;
      const dropdown = this.jobOptionsDropdown.current;

      if (editButtonDropdownActive === true && e.target !== dropdown) {
        this.setState({ editButtonDropdownActive: false });
      }
    });
  };

  render() {
    const {
      applicationsAtOfferOrAccepted,
      handleModalShow,
      isJobActive,
      jobStatus,
    } = this.props;

    const { editButtonDropdownActive } = this.state;

    const jobCanBeClosed =
      !applicationsAtOfferOrAccepted && jobStatus !== "Closed";

    return (
      <JobOptionsButtonWrapper
        id="job-options-button"
        ref={this.jobOptionsDropdown}
        onClick={this.handleJobOptionsButton}
        active={editButtonDropdownActive}
      >
        {editButtonDropdownActive && (
          <DropdownWrapper active={editButtonDropdownActive}>
            <DropdownList>
              {isJobActive && (
                <DropdownListItem
                  onClick={handleModalShow}
                  data-test-id="job-options-edit-job-link"
                >
                  Edit Job
                </DropdownListItem>
              )}
              <DropdownListItem
                onClick={this.handleCopyJobLink}
                data-test-id="job-options-copy-job-link"
              >
                Copy Job
              </DropdownListItem>
              {jobCanBeClosed && (
                <DropdownListItem
                  onClick={this.handleCloseJobLink}
                  data-test-id="job-options-close-job-link"
                >
                  Close Job
                </DropdownListItem>
              )}
            </DropdownList>
          </DropdownWrapper>
        )}
      </JobOptionsButtonWrapper>
    );
  }
}

JobOptionsButton.propTypes = {
  applicationsAtOfferOrAccepted: PropTypes.bool.isRequired,
  handleModalShow: PropTypes.func.isRequired,
  copyJobUrl: PropTypes.string,
  closeJobUrl: PropTypes.string,
  isJobActive: PropTypes.bool.isRequired,
};

JobOptionsButton.defaultProps = {
  copyJobUrl: PropTypes.isNull,
  closeJobUrl: PropTypes.isNull,
};

export default JobOptionsButton;
